// Author Liang Gang Qiang
// Date 2021-11-24 16:34:50

class MintalMesQualitySelfInspectGrind {
constructor({
        id = null,
        selfInspectId = '',
        selfInspectCode = '',
        sampleTime = '',
        inspectTime = '',
        bn101Material = '',
        bn101Grade = '',
        bn101Moisture = '',
        bn101Granularity = '',
        bn102Material = '',
        bn102Grade = '',
        bn102Moisture = '',
        bn102Granularity = '',
        bn103Material = '',
        bn103Grade = '',
        bn103Moisture = '',
        bn103Granularity = '',
        bn104Material = '',
        bn104Grade = '',
        bn104Moisture = '',
        bn104Granularity = '',
        bn105Material = '',
        bn105Moisture = '',
        bn105Carbon = '',
        bn105Sulfur = '',
        bn106Material = '',
        bn106Moisture = '',
        concentration = '',
        granularity1 = '',
        granularity2 = '',
        granularity3 = '',
        granularity4 = '',
        granularity5 = '',
        residue1 = '',
        residue2 = '',
        residue3 = '',
        residue4 = '',
        inspector = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.selfInspectId = selfInspectId;
    this.selfInspectCode = selfInspectCode;
    this.sampleTime = sampleTime;
    this.inspectTime = inspectTime;
    this.bn101Material = bn101Material;
    this.bn101Grade = bn101Grade;
    this.bn101Moisture = bn101Moisture;
    this.bn101Granularity = bn101Granularity;
    this.bn102Material = bn102Material;
    this.bn102Grade = bn102Grade;
    this.bn102Moisture = bn102Moisture;
    this.bn102Granularity = bn102Granularity;
    this.bn103Material = bn103Material;
    this.bn103Grade = bn103Grade;
    this.bn103Moisture = bn103Moisture;
    this.bn103Granularity = bn103Granularity;
    this.bn104Material = bn104Material;
    this.bn104Grade = bn104Grade;
    this.bn104Moisture = bn104Moisture;
    this.bn104Granularity = bn104Granularity;
    this.bn105Material = bn105Material;
    this.bn105Moisture = bn105Moisture;
    this.bn105Carbon = bn105Carbon;
    this.bn105Sulfur = bn105Sulfur;
    this.bn106Material = bn106Material;
    this.bn106Moisture = bn106Moisture;
    this.concentration = concentration;
    this.granularity1 = granularity1;
    this.granularity2 = granularity2;
    this.granularity3 = granularity3;
    this.granularity4 = granularity4;
    this.granularity5 = granularity5;
    this.residue1 = residue1;
    this.residue2 = residue2;
    this.residue3 = residue3;
    this.residue4 = residue4;
    this.inspector = inspector;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesQualitySelfInspectGrind();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.sampleTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.inspectTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn101MaterialName',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn101MaterialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn101Grade',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn101Grade',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn101Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn101Moisture',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn101Granularity',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn101Granularity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn102MaterialName',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn102MaterialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn102Grade',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn102Grade',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn102Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn102Moisture',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn102Granularity',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn102Granularity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn103MaterialName',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn103MaterialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn103Grade',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn103Grade',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn103Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn103Moisture',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn103Granularity',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn103Granularity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn104MaterialName',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn104MaterialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn104Grade',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn104Grade',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn104Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn104Moisture',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn104Granularity',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn104Granularity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn105MaterialName',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn105MaterialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn105Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn105Moisture',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn105Carbon',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn105Carbon',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn105Sulfur',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn105Sulfur',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn106MaterialName',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn106MaterialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bn106Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.bn106Moisture',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'concentration',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.concentration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'granularity1',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.granularity1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'granularity2',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.granularity2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'granularity3',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.granularity3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'granularity4',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.granularity4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'granularity5',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.granularity5',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'residue1',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.residue1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'residue2',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.residue2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'residue3',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.residue3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'residue4',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.residue4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspector',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.inspector',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    selfInspectIdFilter : '',
    selfInspectCodeFilter : '',
    sampleTimeRteFilter : '',
    sampleTimeLteFilter : '',
    inspectTimeRteFilter : '',
    inspectTimeLteFilter : '',
    bn101MaterialFilter : '',
    bn101GradeFilter : '',
    bn101MoistureFilter : '',
    bn101GranularityFilter : '',
    bn102MaterialFilter : '',
    bn102GradeFilter : '',
    bn102MoistureFilter : '',
    bn102GranularityFilter : '',
    bn103MaterialFilter : '',
    bn103GradeFilter : '',
    bn103MoistureFilter : '',
    bn103GranularityFilter : '',
    bn104MaterialFilter : '',
    bn104GradeFilter : '',
    bn104MoistureFilter : '',
    bn104GranularityFilter : '',
    bn105MaterialFilter : '',
    bn105MoistureFilter : '',
    bn105CarbonFilter : '',
    bn105SulfurFilter : '',
    bn106MaterialFilter : '',
    bn106MoistureFilter : '',
    concentrationFilter : '',
    granularity1Filter : '',
    granularity2Filter : '',
    granularity3Filter : '',
    granularity4Filter : '',
    granularity5Filter : '',
    residue1Filter : '',
    residue2Filter : '',
    residue3Filter : '',
    residue4Filter : '',
    inspectorFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'selfInspectCodeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.selfInspectCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualitySelfInspect'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"selfInspectId": "id"}'
                }
        },
        {
        key: 'sampleTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.sampleTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sampleTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.sampleTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.inspectTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.inspectTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'bn101MaterialFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn101Material',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn101GradeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn101Grade',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn101MoistureFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn101Moisture',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn101GranularityFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn101Granularity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn102MaterialFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn102Material',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn102GradeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn102Grade',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn102MoistureFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn102Moisture',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn102GranularityFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn102Granularity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn103MaterialFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn103Material',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn103GradeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn103Grade',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn103MoistureFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn103Moisture',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn103GranularityFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn103Granularity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn104MaterialFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn104Material',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn104GradeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn104Grade',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn104MoistureFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn104Moisture',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn104GranularityFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn104Granularity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn105MaterialFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn105Material',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn105MoistureFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn105Moisture',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn105CarbonFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn105Carbon',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn105SulfurFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn105Sulfur',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn106MaterialFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn106Material',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn106MoistureFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.bn106Moisture',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'concentrationFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.concentration',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity1Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.granularity1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity2Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.granularity2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity3Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.granularity3',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity4Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.granularity4',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity5Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.granularity5',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'residue1Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.residue1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'residue2Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.residue2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'residue3Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.residue3',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'residue4Filter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.residue4',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'inspectorFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.filter.inspector',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'selfInspectCode',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.selfInspectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualitySelfInspect'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"selfInspectId": "id"}'
                }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.sampleTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'inspectTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.inspectTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'bn101Material',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn101Material',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn101Grade',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn101Grade',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn101Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn101Moisture',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn101Granularity',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn101Granularity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn102Material',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn102Material',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn102Grade',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn102Grade',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn102Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn102Moisture',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn102Granularity',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn102Granularity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn103Material',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn103Material',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn103Grade',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn103Grade',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn103Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn103Moisture',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn103Granularity',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn103Granularity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn104Material',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn104Material',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn104Grade',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn104Grade',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn104Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn104Moisture',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn104Granularity',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn104Granularity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn105Material',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn105Material',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn105Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn105Moisture',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn105Carbon',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn105Carbon',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn105Sulfur',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn105Sulfur',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bn106Material',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn106Material',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesPrdCraftMaterialConfig'
            ,showLabelSelectOne: true
                    ,selectFilter:{craftIdFilter: '112'}
        }
        },
        {
        key: 'bn106Moisture',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.bn106Moisture',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'concentration',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.concentration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity1',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.granularity1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity2',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.granularity2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity3',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.granularity3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity4',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.granularity4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity5',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.granularity5',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'residue1',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.residue1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'residue2',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.residue2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'residue3',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.residue3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'residue4',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.residue4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'inspector',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.inspector',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectGrind.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesQualitySelfInspectGrind, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
